// extracted by mini-css-extract-plugin
module.exports = {"link":"Links_link__R798M"};